const radii = {
  S: '0.382rem',
  M: '0.618rem',
  L: '1rem',
};

export default radii;
